import type * as lazyIndex from './lazyIndex';
import { LazyModule, createLazyComponent, LazyAction, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "WhatsNew" */ './lazyIndex'),
    {
        name: 'WhatsNew',
    }
);

export const WhatsNewFluentPane: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.WhatsNewPane
);
export const initializeWhatsNewCardsLazy: LazyAction<
    typeof lazyIndex.initializeWhatsNewIfNecessary,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeWhatsNewIfNecessary);
export const lazyOpenPremiumDashboard: LazyAction<
    typeof lazyIndex.openPremiumDashboard,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openPremiumDashboard);

export { WhatsNewInitSource } from './types/WhatsNewInitSource';
